module.exports = __webpack_public_path__ + "static/media/(H)-06-Capim-Dourado-bijuterias.55cb554d.jpg";